<script setup lang="ts">
defineProps<{ color: string }>()

const { merchantLogo, hasWallet, globalConfig } = useLocalStorage()
const { getContrast } = useColor()
const { t } = useI18n()

const imgSize = ref<string | null>(null)
const logo = ref<HTMLImageElement | null>(null)

const loyaltyPointsByCurrencyUnit = computed(() => globalConfig.value.merchant.loyaltyPointsByCurrencyUnit)
const checkinPoints = computed(() => globalConfig.value.merchant.checkinPoints)

const pointsConfigText = computed(() => {
  if (globalConfig.value.merchant.hasPointsByCurrency) {
    return t(
      'pages.loyaltyPage.mockup.devices.webapp.pointsByCurrency',
      {
        value: loyaltyPointsByCurrencyUnit.value
      },
      Number(loyaltyPointsByCurrencyUnit.value)
    )
  }
  return t(
    'pages.loyaltyPage.mockup.devices.webapp.checkinPoints',
    {
      value: checkinPoints.value
    },
    Number(checkinPoints.value)
  )
})

const isImgSquare = (img: HTMLImageElement) => {
  const width = img.naturalWidth
  const height = img.naturalHeight
  const isSquare = width / height < 2
  return isSquare
}

const updateImgSize = () => {
  if (!logo.value) {
    return
  }
  const isSquare = isImgSquare(logo.value)
  imgSize.value = isSquare ? 'w-16' : 'w-28'
}
</script>

<template>
  <section class="p-6 font-serif" :style="{ background: color, color: getContrast(color) }">
    <div id="header-container">
      <div class="mb-4 w-full">
        <div class="contain mx-auto h-auto" :class="imgSize">
          <img ref="logo" :src="merchantLogo" @load="updateImgSize" />
        </div>
      </div>
      <div class="flex items-center justify-between">
        <div class="relative font-serif">
          <p class="font-bold uppercase">{{ t('pages.loyaltyPage.mockup.devices.webapp.title') }}</p>
          <p class="my-1 text-4xl font-extrabold">100</p>
          <p class="text-sm">
            {{ pointsConfigText }}
          </p>
        </div>
        <div v-if="hasWallet" class="rounded-xl border bg-white p-2">
          <BaseIcon name="HeroQrCodeIconOutline" class="h-7 w-7 cursor-pointer" :style="{ color: color }" />
        </div>
      </div>
    </div>
  </section>
</template>
